import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import FeedbackRoundedIcon from '@mui/icons-material/FeedbackRounded'
import InfoIcon from '@mui/icons-material/Info'
import { FullScreenCalloutVariantsProps } from './_props'
import sxs from './_sxs'

export const variantsProps: FullScreenCalloutVariantsProps = {
    INFO: {
        classes: {
            container: sxs.fullScreenCalloutInfoContainer,
            element: sxs.fullScreenCalloutInfo,
            button: sxs.fullScreenCalloutActionButtonInfo,
        },
        icon: <InfoIcon sx={sxs.fullScreenCalloutInfo} />,
    },
    WARNING: {
        classes: {
            container: sxs.fullScreenCalloutWarningContainer,
            element: sxs.fullScreenCalloutWarning,
            button: sxs.fullScreenCalloutActionButtonWarning,
        },
        icon: <FeedbackRoundedIcon sx={sxs.fullScreenCalloutWarning} />,
    },
    ERROR: {
        classes: {
            container: sxs.fullScreenCalloutErrorContainer,
            element: sxs.fullScreenCalloutError,
            button: sxs.fullScreenCalloutActionButtonError,
        },
        icon: <CancelRoundedIcon sx={sxs.fullScreenCalloutError} />,
    },
}
